import { loggerLink } from '@trpc/client';

// Global TRPC logging control
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- interface needed for augmentation
  interface Window {
    enableTrpcLogging?: () => void;
    disableTrpcLogging?: () => void;
  }
}

let localTrpcLoggingState: boolean;

setTrpcLoggingEnabled((import.meta.env.VITE_TRPC_LOG ?? '1') === '1');

function setTrpcLoggingEnabled(state: boolean) {
  localTrpcLoggingState = state;
  console.info(`tRPC logging is ${localTrpcLoggingState ? 'enabled' : 'disabled'}`);
}

if (typeof window !== 'undefined') {
  window.enableTrpcLogging = () => {
    setTrpcLoggingEnabled(true);
  };

  window.disableTrpcLogging = () => {
    setTrpcLoggingEnabled(false);
  };
}

export const deactivatableLoggerLink = loggerLink({
  enabled: () => localTrpcLoggingState,
});
